import { createBrowserRouter } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { Register } from "../pages/login";
import { ResetPassword } from "../pages/resetPassword";
import { AuthGuard } from "../utils";
import CallbackHandler from "../pages/callback/CallbackHandler";
import theme from "../theme";
import AdminPortal from "../Admin/AdminPortal";
import Vkyc from "../kyc/Vkyc";
import NavigateProvider from "./AppWrapper"; 

const router = createBrowserRouter([
  {
    path: "/",                   
    element: <NavigateProvider />, 
    children: [
      {
        path: "/vkyc/dashboard",
        element: <AuthGuard />,
        children: [
          {
            index: true,
            element: <AdminPortal />,
          },
        ],
      },
      {
        path: "/vkyc",
        element: <Vkyc />,
      },
      {
        path: "/vkyc/login",
        element: (
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Register />
          </ThemeProvider>
        ),
      },
      {
        path: "/vkyc/reset-password",
        element: (
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <ResetPassword />
          </ThemeProvider>
        ),
      },
      {
        path: '/vkyc/callback',
        element: <CallbackHandler />,
      },
    ],
  },
]);

export default router;
